import { Box, Typography } from 'shared/ui'
import { type IResponseUser } from 'entities/Users/api/types'
import styles from './styles.module.scss'

type IMemberLabelProps = {
  member: IResponseUser
}

export const MemberLabel = ({ member }: IMemberLabelProps) => {
  return (
    <Box display={'flex'} justifyContent={'space-between'}>
      <Typography
        ellipsis
        variant='text-input-field-r'
        color='var(--content-primary-primary)'
        ariaLabel='Contact name'
      >
        {member.full_name || `${member.first_name} ${member.last_name}`}
      </Typography>
      <Typography
        className={styles.labelContentEmail}
        color='var(--content-primary-tertiary)'
        ariaLabel='Contact email'
        variant='body-xs-regular'
        ellipsis
      >
        {member.email}
      </Typography>
    </Box>
  )
}
